export default __webpack_public_path__ + "static/media/win-10-enterprise.10cce381.png";